import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton } from '../../../components/common';
const DropdownControl = ({ label, options, }) => (_jsx("div", { className: "leaflet-top leaflet-right mr-12 !z-[1001]", children: _jsx("div", { className: "leaflet-control !cursor-pointer", children: _jsx(DropdownButton, { classNames: "rounded-lg border-2 border-black/25", label: label, color: "white", options: options }) }) }));
export default DropdownControl;
